import { FC, useState } from "react";
import { useUserContext } from "../../providers/userProvider";
import { v4 as uuid } from "uuid";
import { ref, set } from "firebase/database";
import { database } from "../../../firebase/firebase-config";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";

export const AddGsm: FC = () => {
  const [brand, setBrand] = useState<string>("");
  const [model, setModel] = useState<string>("");
  const [Date_IN, setDate_IN] = useState<string>("");
  const [Date_OUT, setDate_OUT] = useState<string>("");
  const [IMEI_number, setIMEI_number] = useState<number>(0);
  const [SIN_Number, setSIN_Number] = useState<string>("");
  const [PV_number, setPV_number] = useState<string>("");
  const [SIM_code, setSIM_code] = useState<number>(0);
  const [Unlock_code, setUnlock_code] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const { user } = useUserContext();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    resetFields();
  };

  const resetFields = () => {
    setBrand("");
    setModel("");
    setDate_IN("");
    setDate_OUT("");
    setIMEI_number(0);
    setSIN_Number("");
    setPV_number("");
    setSIM_code(0);
    setUnlock_code("");
  };

  const onAddGSM = async () => {
    try {
      const id = uuid();
      const username = user?.email;

      if (!brand || !model || !Date_IN) {
        setError("Please fill in all required fields");
        return;
      }

      await set(ref(database, `GSM/${id}`), {
        id,
        brand,
        model,
        Date_IN,
        Date_OUT,
        IMEI_number,
        SIN_Number,
        PV_number,
        SIM_code,
        Unlock_code,
        createdByUser: username,
        createdAt: new Date().toISOString(),
      });

      // Send notification
      await fetch("/api/add-gsm", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ brand, model, Date_IN }),
      });

      setError(null); // Clear any previous errors
      handleClickOpen();
    } catch (error) {
      console.error("Error adding GSM:", error);
      setError("Failed to add GSM. Please try again.");
    }
  };

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        onAddGSM();
      }}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      sx={{ padding: 2 }}
    >
      <Typography
        variant="h5"
        fontWeight={"bold"}
        sx={{ padding: 2 }}
        gutterBottom
      >
        Add GSM
      </Typography>
      <TextField
        variant="outlined"
        label="Brand"
        value={brand}
        onChange={(e) => setBrand(e.target.value)}
        required
        helperText="Merk?"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="Model"
        value={model}
        onChange={(e) => setModel(e.target.value)}
        required
        helperText="Model?"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="Date IN"
        value={Date_IN}
        onChange={(e) => setDate_IN(e.target.value)}
        required
        helperText="DD/MM/YYYY"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="Date OUT"
        value={Date_OUT}
        onChange={(e) => setDate_OUT(e.target.value)}
        required
        helperText="DD/MM/YYYY"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="IMEI Number"
        value={IMEI_number}
        onChange={(e) => setIMEI_number(Number(e.target.value))}
        required
        helperText="15 
        cijfers"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="SIN Number"
        value={SIN_Number}
        onChange={(e) => setSIN_Number(e.target.value)}
        required
        helperText="AAAA0000"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="PV Number"
        value={PV_number}
        onChange={(e) => setPV_number(e.target.value)}
        required
        helperText="AN.??.L3.??????/2024"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="SIM Code"
        value={SIM_code}
        onChange={(e) => setSIM_code(Number(e.target.value))}
        required
        helperText="4-cijferige code"
        sx={{ marginBottom: 2 }}
      />
      <TextField
        variant="outlined"
        label="Unlock code"
        value={Unlock_code}
        onChange={(e) => setUnlock_code(e.target.value)}
        required
        helperText="Code of ontgrendeling beschrijven"
        sx={{ marginBottom: 2 }}
      />

      <Button type="submit" variant="contained" color="primary">
        Add GSM
      </Button>
      {error && <Typography color="error">{error}</Typography>}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{"Phone Added Successfully"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The phone has been added successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AddGsm;
